/* ==========================================
   THE FK FRAGRANCES - THEME JAVASCRIPT
   ========================================== */

document.addEventListener('DOMContentLoaded', function() {
  // Mobile Menu Toggle
  const mobileMenuOpen = document.getElementById('MobileMenuOpen');
  const mobileMenuClose = document.getElementById('MobileMenuClose');
  const mobileNav = document.getElementById('MobileNav');
  const mobileOverlay = document.getElementById('MobileOverlay');
  
  if (mobileMenuOpen && mobileNav && mobileOverlay) {
    mobileMenuOpen.addEventListener('click', function() {
      mobileNav.classList.add('is-open');
      mobileOverlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    });
    
    const closeMobileMenu = function() {
      mobileNav.classList.remove('is-open');
      mobileOverlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    };
    
    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', closeMobileMenu);
    }
    
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }
  
  // Announcement Bar Close
  const announcementClose = document.getElementById('AnnouncementClose');
  const announcementBar = document.getElementById('AnnouncementBar');
  
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', function() {
      announcementBar.style.display = 'none';
    });
  }
  
  // Quick Add to Cart (basic implementation)
  const quickAddButtons = document.querySelectorAll('.js-quick-add');
  
  quickAddButtons.forEach(button => {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      
      if (variantId) {
        // This is a basic placeholder - in a real Shopify theme, you'd use the Shopify AJAX API
        // For now, we'll just redirect to the cart page
        window.location.href = '/cart/add?id=' + variantId;
      }
    });
  });
  
  // Smooth scroll for anchor links
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      
      if (href !== '#') {
        const target = document.querySelector(href);
        
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
  
  // Back to Top
  const backToTopBtn = document.getElementById('BackToTop');
  
  if (backToTopBtn) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        backToTopBtn.classList.add('is-visible');
      } else {
        backToTopBtn.classList.remove('is-visible');
      }
    });
    
    backToTopBtn.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
  
  console.log('The FK Fragrances theme initialized');
});
